<div class="flex-control flex-column">
  <app-tabs>
    <li (click)="tabs_service.deactivate_tab()" [class.active]="!tabs_service.is_active()">Rich Text Templates</li>
  </app-tabs>
  <app-rich-text-templates class="flex-control flex-column" [hidden]="tabs_service.is_active()"></app-rich-text-templates>
</div>
